import { ChatEmoji } from '../model/chat-emoji';

/** Stable key for catalog dedupe, reactions, and recent-emoji storage (`id:…` or `char:…`). */
export function getEmojiKey(emoji: ChatEmoji): string | null
{
  if (emoji.id)
  {
    return `id:${emoji.id}`;
  }

  if (emoji.char)
  {
    return `char:${emoji.char}`;
  }

  return null;
}
